import { useScanDeviceApiDetailQuery } from '@hooks/api/useScanDeviceApiDetailQuery';
import type { HardwareVersion } from 'types/api';

export const useHardwareVersion =
  useScanDeviceApiDetailQuery<HardwareVersion>('/hardware-versions');
